import { create } from "zustand";
import { FidelityProposalState, FidelityProposalStateValues } from "./types";

const initialValues: FidelityProposalStateValues = {
  proposalData: undefined
};

export const useFidelityProposalStore = create<FidelityProposalState>()(
  (set, get) => ({
    ...initialValues,
    setProposalData: (data) => {
      set({ proposalData: data });
    },
    updateProposalData: (data) => {
      const current = get();
      if (current.proposalData) {
        const updated = {
          ...current.proposalData,
          ...data
        };
        set({
          proposalData: updated
        });
      } else {
        set({ proposalData: data });
      }
    },
    resetFidelityProposalStore: () => {
      set(initialValues);
    }
  })
);
